import React, { type ReactNode } from 'react';
import { PrefaceMode } from '../../PrefaceEditor';
import { GuideSheet, ReleaseNotes } from 'views/App/Portal/Policy/_types/manuals/draft';
import { PanesContentSelector } from './PaneSelector';
import { PaneContentWrapper } from './PaneContentWrapper';
import GuideSheetDrawer from '../../GuideSheet/GuideSheetDrawer';
import ReleaseNotesDrawer from '../../ReleaseNotes/ReleaseNotesDrawer';

interface ContentPanesProps {
  activePaneId: string;
  mode: PrefaceMode;
  isLoading?: boolean;
  guideSheets?: {
    guideSheet?: GuideSheet | undefined;
    manualLevel?: string;
    onApproveGuideSheet: () => Promise<void>;
  };
  releaseNotes?: {
    onNoteIndexChange: (addNumber: number) => void;
    currentNoteIndex: number;
    handleApproveReleaseNotes: () => Promise<void>;
    releaseNotes?: ReleaseNotes | null;
    emptyMessage?: string;
  };
  pendingUpdates?: ReactNode;
}

export const Content = ({ activePaneId, releaseNotes, guideSheets, isLoading, mode, pendingUpdates }: ContentPanesProps) => {
  return (
    <PanesContentSelector activePaneId={activePaneId}>
      <PaneContentWrapper paneId='guideSheet'>
        {guideSheets && (
          <GuideSheetDrawer
            guideSheet={guideSheets.guideSheet}
            manualLevel={guideSheets.manualLevel}
            onApproveGuideSheet={guideSheets.onApproveGuideSheet}
            isEditing={mode === 'EDITING'}
          />
        )}
      </PaneContentWrapper>
      <PaneContentWrapper paneId='releaseNotes'>
        {releaseNotes && (
          <ReleaseNotesDrawer
            releaseNotes={releaseNotes.releaseNotes}
            onNoteIndexChange={releaseNotes.onNoteIndexChange}
            currentNoteIndex={releaseNotes.currentNoteIndex}
            isLoading={isLoading}
            isEditing={mode === 'EDITING'}
            handleApproveReleaseNotes={releaseNotes.handleApproveReleaseNotes}
            emptyMessage={releaseNotes.emptyMessage}
          />
        )}
      </PaneContentWrapper>
      <PaneContentWrapper paneId='pendingUpdates'>
        {pendingUpdates}
      </PaneContentWrapper>
    </PanesContentSelector>
  );
};
